export default "__VITE_ASSET__f5407100__"